import {NotifyPropertyChanged} from '../utils/NotifyPropertyChanged.js';

export enum UIState {
    none,
    title,
    pause,
    options,
}

/**
 * Model for the UI. This model is used to keep track of the state of the UI.
 * It can be slightly different from the state of the game.
 */
export class UIModel extends NotifyPropertyChanged<UIModel> {
    private _state = UIState.none;
    set state(value) {
        if (value !== this._state) {
            const oldValue = this._state;
            this._state = value;
            this.notifyPropertyChanged('state', this._state, oldValue);
        }
    }
    get state() {
        return this._state;
    }
}
